import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
import { CustomBlock } from '../../../../FlexibleCard/components/blocks';
import ActionGroup from '../../../../FlexibleCard/components/blocks/action-group';
import { LoadingSkeletonNew, LoadingSkeletonOld } from '../../../../FlexibleCard/components/common/loading-skeleton';
import Icon from '../../../../FlexibleCard/components/elements/icon';
import { CARD_WIDTH_REM } from '../../../styled';
import { getTitleStyles, loadingViewContainer, skeletonContainer, titleBlockStyles } from './styled';
var HoverCardLoadingViewOld = function HoverCardLoadingViewOld(_ref) {
  var titleBlockProps = _ref.titleBlockProps;
  var testId = 'hover-card-loading-view';
  var lineHeightRem = 1.25;
  var skeletonWidth = CARD_WIDTH_REM - 2;
  var size = titleBlockProps.size,
    actions = titleBlockProps.actions;
  var actionGroup = (actions === null || actions === void 0 ? void 0 : actions.length) && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && jsx(ActionGroup, {
    items: actions,
    visibleButtonsNum: 2
  });
  var LoadingSkeleton = fg('platform-smart-card-icon-migration') ? LoadingSkeletonNew : LoadingSkeletonOld;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: loadingViewContainer,
      "data-testid": testId
    }, jsx("div", {
      css: skeletonContainer
    }, jsx(CustomBlock, _extends({}, titleBlockProps, {
      overrideCss: titleBlockStyles,
      testId: "".concat(testId, "-title-block")
    }), jsx(Icon, {
      render: function render() {
        return jsx(LoadingSkeleton, null);
      },
      size: size
    }), jsx("span", {
      css: getTitleStyles(lineHeightRem),
      "data-testid": "".concat(testId, "-title")
    }, fg('platform-smart-card-icon-migration') ? jsx(LoadingSkeletonNew, {
      height: "".concat(lineHeightRem, "rem")
    }) : jsx(LoadingSkeletonOld, {
      height: lineHeightRem
    })), actionGroup), fg('platform-smart-card-icon-migration') ? jsx(React.Fragment, null, jsx(LoadingSkeletonNew, {
      width: "".concat(skeletonWidth, "rem"),
      height: "".concat(lineHeightRem, "rem")
    }), jsx(LoadingSkeletonNew, {
      width: "".concat(skeletonWidth, "rem"),
      height: "".concat(lineHeightRem * 3, "rem")
    }), jsx(LoadingSkeletonNew, {
      width: "".concat(skeletonWidth, "rem"),
      height: "".concat(lineHeightRem, "rem")
    })) : jsx(React.Fragment, null, jsx(LoadingSkeletonOld, {
      width: skeletonWidth,
      height: lineHeightRem
    }), jsx(LoadingSkeletonOld, {
      width: skeletonWidth,
      height: lineHeightRem * 3
    }), jsx(LoadingSkeletonOld, {
      width: skeletonWidth,
      height: lineHeightRem
    }))))
  );
};
export default HoverCardLoadingViewOld;